
    var riot = require('riot')
    riot.tag2('gb-search-box', '<input ref="searchBox" type="text" placeholder="Search..." autofocus>', 'gb-search-box.gb-stylish > input,[data-is="gb-search-box"].gb-stylish > input{ padding: 6px 12px; font-size: 14px; }', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/query/gb-search-box.tag.html